import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import "./App.css";
import { initConfig, initValues } from "./utils/fetcher";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import Content from "./containers/Content";
import SideBarRight from "./containers/SideBarRight";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core";
import AlertDialog from "./components/AlertDialog";
import IdleTimer from "react-idle-timer";
import Faq from "./containers/Faq";
import { closeMainDialog, showFaq } from "./actions";
import PatientArea from "./containers/PatientArea";
import ConnexionPatientArea from "./app/patient-area/ConnexionPatientArea";
import AlertDialogView2 from "./components/AlertDialogView2";
import ExternalUserQrCode from "./components/ExternalUserQrCode";
import PriorityCode from "./components/PriorityCode";
import ContentSMS from "./components/sms/ContentSMS";

const styles = () => ({
  dialog: {
    maxWidth: "980px",
    width: "100%"
  },
  dialogPaper: { overflow: "visible" },
  container: {
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
      borderRadius: "0" // full height on laptop and smaller screens
    },
    [theme.breakpoints.down("md")]: {
      width: "100vw",
      borderRadius: "0" // full width on laptop and smaller screens
    },
    backgroundColor: "#e0e0e0",
    borderRadius: "6px"
  }
});

const theme = createTheme({
  palette: {
    primary: { main: "#117BA2", contrastText: "#ffffff" },
    secondary: { main: "#D2EBF1", contrastText: "#117BA2" },
    error: { main: "#D9736B", contrastText: "#ffffff" }
  },
  typography: { useNextVariants: true },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: ".9rem",
        backgroundColor: "#117BA2"
      }
    },
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "#D1D1D1" // Change outline color to blue
        },
        "&:hover $notchedOutline": {
          borderColor: "#2196f3" // Change outline color to blue on hover
        },
        "&$focused $notchedOutline": {
          borderColor: "#2196f3" // Change outline color to blue on focus
        }
      }
    },
    MuiInputBase: {
      root: {
        backgroundColor: "transparent"
      }
    },
    MuiLink: {
      root: {
        color: "#009EFF" // Change link text color to red
      }
    }
  }
});

const cpTheme = createTheme({
  palette: {
    primary: { main: "#009eff", contrastText: "#ffffff" },
    secondary: { main: "#009eff", contrastText: "#ffffff" },
    error: { main: "#D9736B", contrastText: "#ffffff" }
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: ".9rem",
        backgroundColor: "#1F3A55"
      },
      arrow: {
        color: "#1F3A55"
      }
    }
  }
});

class App extends Component {
  constructor(props) {
    console.log("V-2.3.2503");
    super(props);
    this.state = {
      isOpenSideBar: true,
      isOpen: true
    };
  }

  noBg = initValues().noBG;

  componentDidMount() {
    this.props.getConfig();
    const queryParams = new URLSearchParams(window.location.search);
    if (
      queryParams.get("page") &&
      !queryParams.get("token") &&
      queryParams.get("page") === "sms"
    ) {
      this.setState({ isOpenSideBar: false });
    }
  }

  toggleSideBar = () => {
    this.setState({ isOpenSideBar: !this.state.isOpenSideBar });
  };

  onIdle = () => {
    this.props.showFaq(true);
  };

  mode = () => {
    if (this.props.isFailed) {
      return "fail";
    }
    if (this.props.isOriginQrCode) {
      return "originQrCode";
    }
    const isLoggedIn = Object.keys(this.props.user.userData).length > 0;
    if (this.props.isPatientArea && !isLoggedIn) {
      return "login";
    }
    if (this.props.isPatientArea && isLoggedIn) {
      return "account";
    }
    const queryParams = new URLSearchParams(window.location.search);
    if (
      queryParams.get("page") &&
      !queryParams.get("token") &&
      queryParams.get("page") === "sms"
    ) {
      return "sms";
    }
    return "rdv";
  };

  closeMainDialog = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    window.parent.postMessage({ event_id: "closeiframe" }, "*");
    this.props.closeMainDialog();
  };

  getAppBody = (appMode, isOpenSideBar, classes) => {
    const noModal = initValues().noModal;
    let bodyContent = (
      <div>
        {appMode === "fail" && <AlertDialog onClick={this.closeMainDialog} />}
        {appMode === "originQrCode" && <ExternalUserQrCode />}
        {appMode === "login" && (
          <MuiThemeProvider theme={cpTheme}>
            <ConnexionPatientArea />
          </MuiThemeProvider>
        )}
        {appMode === "account" && <PatientArea />}
        {appMode === "rdv" && (
          <Grid container className="main-bg">
            <Grid className="col-l" item xs={isOpenSideBar ? 9 : 12}>
              {this.props.isLoading && (
                <div className="wrap-circular-progress">
                  <div className="la-ball-spin-fade-rotating la-2x primary">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              )}
              <Content
                toggleSideBar={this.toggleSideBar}
                isOpenSideBar={isOpenSideBar}
                isShowBtnInfo={!!this.props.configuration.infoSide}
              />
              {this.props.alertDialog.content && (
                <AlertDialog
                  content={this.props.alertDialog.content}
                  isOpen={true}
                />
              )}
              {this.props.isShowCodePrioritaire && (
                <PriorityCode isShow={true} />
              )}
              {this.props.configuration.messagealert && (
                <AlertDialogView2
                  content={this.props.configuration.messagealert}
                />
              )}
              {this.props.isShowFaq && <Faq />}
            </Grid>

            {isOpenSideBar && (
              <Grid className="col-r" item xs={3}>
                <SideBarRight
                  infoSide={
                    this.props.configuration &&
                    this.props.configuration.infoSide
                  }
                />
              </Grid>
            )}
          </Grid>
        )}
        {appMode === "sms" && (
          <Grid container className="main-bg">
            <Grid className="col-l" item xs={isOpenSideBar ? 9 : 12}>
              {this.props.isLoading && (
                <div className="wrap-circular-progress">
                  <div className="la-ball-spin-fade-rotating la-2x primary">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              )}
              <ContentSMS
                toggleSideBar={this.toggleSideBar}
                isOpenSideBar={isOpenSideBar}
                classes={classes}
              />
              {this.props.alertDialog.content && (
                <AlertDialog
                  content={this.props.alertDialog.content}
                  isOpen={true}
                />
              )}
              {this.props.isShowCodePrioritaire && (
                <PriorityCode isShow={true} />
              )}
              {this.props.configuration.messagealert && (
                <AlertDialogView2
                  content={this.props.configuration.messagealert}
                />
              )}
              {this.props.isShowFaq && <Faq />}
            </Grid>

            {isOpenSideBar && (
              <Grid className="col-r" item xs={3}>
                <SideBarRight
                  infoSide={
                    this.props.configuration &&
                    this.props.configuration.infoSide
                  }
                />
              </Grid>
            )}
          </Grid>
        )}
      </div>
    );

    if (noModal) {
      return bodyContent;
    }
    return (
      <Dialog
        open={this.props.mainDialog}
        onClose={this.closeMainDialog}
        className="main-dialog"
        classes={{
          paper: classes.dialog
        }}
        BackdropProps={{ open: !this.noBg }}
      >
        {bodyContent}
      </Dialog>
    );
  };

  render() {
    const { classes } = this.props;
    const appMode = this.mode();
    const isOpenSideBar =
      this.props.configuration.infoSide !== undefined &&
      this.props.configuration.infoSide.length > 0 &&
      this.state.isOpenSideBar;
    return (
      <MuiThemeProvider theme={appMode === "account" ? cpTheme : theme}>
        <div className="App">
          <IdleTimer
            element={document}
            onIdle={this.onIdle}
            debounce={250}
            timeout={1000 * 60 * 2}
          />
          {this.getAppBody(appMode, isOpenSideBar, classes)}
        </div>
      </MuiThemeProvider>
    );
  }
}

App.propTypes = {
  alertDialog: PropTypes.shape({
    content: PropTypes.any
  }),
  classes: PropTypes.shape({
    dialog: PropTypes.any,
    dialogPaper: PropTypes.any,
    container: PropTypes.any
  }),
  closeMainDialog: PropTypes.func,
  configuration: PropTypes.shape({
    infoSide: PropTypes.any,
    messagealert: PropTypes.any
  }),
  getConfig: PropTypes.func,
  isFailed: PropTypes.bool,
  isLoading: PropTypes.bool,
  isOriginQrCode: PropTypes.bool,
  isPatientArea: PropTypes.bool,
  isShowCodePrioritaire: PropTypes.bool,
  isShowFaq: PropTypes.bool,
  mainDialog: PropTypes.any,
  showFaq: PropTypes.func,
  user: PropTypes.shape({
    userData: PropTypes.any
  })
};

const mapStateToProps = state => {
  return {
    isFailed: state.loader.isFailed,
    isLoading: state.loader.isLoading,
    configuration: state.configuration,
    alertDialog: state.alertDialog,
    isShowFaq: state.showFaq,
    mainDialog: state.mainDialog,
    isPatientArea: state.patientArea.active,
    user: state.user,
    isOriginQrCode: state.externalPatientsQrCode.originQrCode,
    isShowCodePrioritaire: state.isShowCodePrioritaire
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getConfig: () => dispatch(initConfig()),
    showFaq: isShow => dispatch(showFaq(isShow)),
    closeMainDialog: () => dispatch(closeMainDialog())
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);
